// errors that are only used internally within the web client; the server doesn't know about these
export const UNAUTHORIZED = -1;
export const SERVER_ERROR = -2;
export const NETWORK_ERROR = -3;
